import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=13fa267e&scoped=true&"
import script from "./PostFeed.vue?vue&type=script&lang=ts&"
export * from "./PostFeed.vue?vue&type=script&lang=ts&"
import style0 from "./PostFeed.vue?vue&type=style&index=0&id=13fa267e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa267e",
  null
  
)

export default component.exports